import React from "react";
import "./TestSummaryModal.css";

interface Props {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  summary: {
    sectionName: string | undefined;
    totalQuestions: number;
    answered: number;
    notAnswered: number;
    markedForReview: number;
    notVisited: number;
  };
}

const TestSummaryModal: React.FC<Props> = ({ show, onClose, onSubmit, summary }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-lg">
        <h5 className="mb-4">Submit Your Test</h5>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Section</th>
              <th>No. of Questions</th>
              <th>Answered</th>
              <th>Not Answered</th>
              <th>Marked for Review</th>
              <th>Not Visited</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{summary.sectionName}</td>
              <td>{summary.totalQuestions}</td>
              <td>{summary.answered}</td>
              <td>{summary.notAnswered}</td>
              <td>{summary.markedForReview}</td>
              <td>{summary.notVisited}</td>
            </tr>
          </tbody>
        </table>

        <div className="text-end mt-4">
          <button className="btn btn-warning me-3" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={onSubmit}>Submit</button>
        </div>
      </div>
    </div>
  );
};

export default TestSummaryModal;
